import React, { useEffect, useState } from 'react';
import {
  MemoryRouter as Router,
  BrowserRouter as AppRouter,
  Route,
  Switch,
} from 'react-router-dom';

import Amplify from 'aws-amplify'; /*, { API }*/
import awsmobile from './aws-exports';

import { IntlProvider } from 'react-intl';
import * as Langs from './compiled-lang';

import { LoaderContextProvider } from './context/LoaderContextProvider';
import { AuthContextProvider } from './context/AuthContextProvider';
import { SizeContextProvider } from 'context/SizeContextProvider';
import { CartContextProvider } from 'context/CartContextProvider';
import { VisitsContextProvider } from 'context/VisitsContextProvider';

import NotFound from './pages/NotFound';
import BrandArea from './pages/breakout/brandArea/BrandArea';
import UserArea from './pages/breakout/userArea/UserArea';
import AdminArea from './pages/breakout/adminArea/AdminArea';
import Details from './pages/breakout/userArea/Details';
import BreakoutRoomForm from './pages/breakout/brandArea/BreakoutRoomForm';
import BreakoutRoomInvitationsHandler from './pages/breakout/brandArea/BreakoutRoomInvitationsHandler';
import ChatSessionRouter from './pages/ChatSessionRouter';
import SalesTeam from 'pages/agenda/SalesTeam';
import Agenda from 'pages/agenda/Agenda';
import CreateVisit from 'pages/agenda/CreateVisit';
import BookingPage from 'pages/agenda/BookingPage';
import { purposesEnum, routes } from './utils/constants';
import { Roles, defaultLang } from './utils/constants';
import ExhibitorBooking from 'pages/exhibitor/exhibitorBooking/ExhibitorBooking';
import RequestPage from 'pages/agenda/RequestPage';
import AgendaOperator from 'pages/agenda/AgendaOperator';
import ExhibitorMap from 'pages/exhibitor/exhibitorMap/ExhibitorMap';
import MyAppointmentDetail from 'pages/agenda/MyAppointmentDetail';
import BrPublicDetail from 'pages/breakout/userArea/BrPublicDetail';

import JsonApiNodeSwitch from 'pages/jsonapiNodes/JsonApiNodeSwitch';
import ProductCreate from 'pages/jsonapiNodes/ProductCreate';
import TicketsPendingOrderPage from 'pages/tickets/TicketsPendingOrderPage';
import ThemeV5Provider from 'themeV5';
import AssignTicket from 'pages/ticketV2/AssignTicket';
import TicketsBuyHomePage from 'pages/ticketV2/Buy';
import Recap from 'pages/ticketV2/Recap';

import { SdmAlertV5 } from 'components/SdmAlertV5';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTicketsStore } from 'pages/ticketV2/store/ticketsStore';
import CheckoutPage from 'pages/tickets/CheckoutPage';
import Merchandising from 'pages/ticketV2/Merchandising';
import SuccessPage from 'pages/ticketV2/Success';
import { LoaderCountContextProvider } from 'context/LoaderV5';
import PersonalTickets from 'pages/ticketV2/PersonalTickets';
import PersonalOrders from 'pages/ticketV2/PersonalOrders';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HomePage from 'pages/exhibitorsV2/Homepage';
import { FilterContextProvider } from 'context/FilterContextProvider';
import { ExhibitorContextProvider } from 'context/ExhibitorContextProvider';
import PersonalPage from 'pages/exhibitorsV2/PersonalPage';
import ExhibitorDetail from 'pages/exhibitorsV2/ExhibitorDetail';
import { useBookmarkStore } from 'pages/exhibitor/exhibitorBookmarks';
import MatchMakingPage from 'pages/analyticsV2';
import { useMatchMakingStore } from 'pages/analyticsV2/common/store';
import Biennali from 'pages/exhibitorsV2/Homepage/Biennali';

Amplify.configure(awsmobile);

function App() {
  const [loggedUser, setLoggedUser] = useState();
  const [detectedEmail, setDetectedEmail] = useState(false);
  const [locale, setLocale] = useState(defaultLang);
  const [jsonApiLang, setJsonApiLang] = useState();
  const [user, setUser] = useState();
  const [brId, setBrId] = useState('');

  const { alertData } = useTicketsStore();
  const { alertData: exhibitorAlertData } = useBookmarkStore();
  const { alertData: matchmakingAlertData } = useMatchMakingStore();

  useEffect(() => {
    const checkParams = async () => {
      const lang = window.location.pathname.split('/')[1];
      setLocale(lang && lang.length === 2 ? lang : defaultLang);
      if ((lang && lang.length === 2) || defaultLang)
        setJsonApiLang(lang || defaultLang);
      const params = new URLSearchParams(location.search);
      const _brId = params.get('br-id');
      if (_brId) setBrId(_brId);
    };
    const drupalMsgs = document.getElementsByClassName('messages__wrapper');
    if (drupalMsgs && drupalMsgs?.length) {
      drupalMsgs[0].style.display = 'none';
    }

    checkParams();
  }, [location.pathname, location.search]);

  useEffect(() => {
    setLoggedUser(user);
  }, [user]);

  //const apiName = 'virtualEventInterface';
  //const path = `/external-session/abcd-simo?language=it`;
  //API.post(apiName, path).then(console.log).catch(console.error);

  return (
    <IntlProvider locale={locale} messages={Langs[locale]} onError={() => {}}>
      <LoaderContextProvider
        minHeight={
          window.location.pathname.includes('analytics') ? '600px' : '120px'
        }
      >
        <AppRouter>
          <Switch>
            {/*
             * Ticketing 2.0 Routing
             */}
            <Route
              exact
              path={[
                '/:lang/sdm-tickets/buy',
                '/sdm-tickets/buy',
                '/:lang/app/sdm-tickets/buy',
                '/app/sdm-tickets/buy',
                '/:lang/sdm-tickets/buy2',
                '/sdm-tickets/buy2',
                /**
                 * Localhost Routing
                 */
                // '/:lang/tickets',
                // '/tickets',
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <ThemeV5Provider>
                    <LoaderCountContextProvider>
                      <Router>
                        <CartContextProvider loggedUser={loggedUser}>
                          {!loggedUser ? (
                            <></>
                          ) : (
                            <Switch>
                              <Route exact path="/">
                                <TicketsBuyHomePage
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/merch">
                                <Merchandising
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/assign-ticket">
                                <AssignTicket
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/recap">
                                <Recap
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/checkout">
                                <CheckoutPage
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                            </Switch>
                          )}
                          <SdmAlertV5
                            severity={alertData?.severity || 'warning'}
                            variant="filled"
                            icon={
                              alertData?.severity === 'error' ? (
                                <WarningAmberIcon color="error" />
                              ) : alertData?.severity === 'success' ? (
                                <CheckCircleOutlineIcon color="success" />
                              ) : (
                                <InfoOutlinedIcon color="warning" />
                              )
                            }
                            alertData={alertData}
                          />
                        </CartContextProvider>
                      </Router>
                    </LoaderCountContextProvider>
                  </ThemeV5Provider>
                </AuthContextProvider>
              </Router>
            </Route>
            {/*
             * Routing for Product create/edit
             */}
            <Route
              exact
              path={[
                '/:lang/sdm-editor/add/node/prodotto',
                '/sdm-editor/add/node/prodotto',
              ]}
            >
              <Router>
                <Switch>
                  <Route exact path="/">
                    <ProductCreate jsonApiLang={jsonApiLang} />
                  </Route>
                </Switch>
              </Router>
            </Route>
            <Route
              exact
              path={[
                '/:lang/sdm-editor/node/:bundle/:id',
                '/sdm-editor/node/:bundle/:id',
              ]}
            >
              <Router>
                <Switch>
                  <Route exact path="/">
                    <JsonApiNodeSwitch jsonApiLang={jsonApiLang} />
                  </Route>
                </Switch>
              </Router>
            </Route>
            <Route exact path={['/:lang/breakout', '/breakout']}>
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  {/* <div style={{ width: '80%', margin: '0 auto', maxWidth: 1250 }}> */}
                  {!loggedUser ? (
                    <></>
                  ) : loggedUser.type === Roles.BRAND ? (
                    <Switch>
                      <Route exact path="/">
                        <BrandArea
                          user={loggedUser}
                          detectedEmail={detectedEmail}
                        />
                      </Route>
                      <Route exact path="/breakoutRoom">
                        <BreakoutRoomForm locale={locale} />
                      </Route>
                      <Route exact path="/invite">
                        <BreakoutRoomInvitationsHandler
                          purpose={purposesEnum.INVITE}
                          locale={locale}
                        />
                      </Route>
                      <Route exact path="/deleteBreakoutRoom">
                        <BreakoutRoomInvitationsHandler
                          purpose={purposesEnum.DELETE}
                          locale={locale}
                        />
                      </Route>
                      <Route exact path="/removeUser">
                        <BreakoutRoomInvitationsHandler
                          purpose={purposesEnum.REMOVE}
                          locale={locale}
                        />
                      </Route>
                      <Route component={NotFound} />
                    </Switch>
                  ) : loggedUser.type === Roles.ADMIN ? (
                    <Switch>
                      <Route exact path="/">
                        <AdminArea user={loggedUser} />
                      </Route>
                      <Route component={NotFound} />
                    </Switch>
                  ) : (
                    <Switch>
                      {brId ? (
                        <Route exact path="/">
                          <BrPublicDetail
                            user={loggedUser}
                            detectedEmail={detectedEmail}
                            locale={locale}
                          />
                        </Route>
                      ) : (
                        <Route exact path="/">
                          <UserArea
                            user={loggedUser}
                            detectedEmail={detectedEmail}
                            locale={locale}
                          />
                        </Route>
                      )}
                      <Route exact path="/details">
                        <Details user={loggedUser} />
                      </Route>
                      <Route component={NotFound} />
                    </Switch>
                  )}
                  {/* </div> */}
                </AuthContextProvider>
              </Router>
            </Route>
            {/*
             * Exhibitors 2.0 Routing
             */}
            <Route
              exact
              path={[
                '/:lang/exhibitors',
                '/exhibitors',
                '/:lang/exhibitors2',
                '/exhibitors2',
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <FilterContextProvider locale={locale}>
                    <ThemeV5Provider>
                      <LoaderCountContextProvider>
                        <Router>
                          <Switch>
                            <ExhibitorContextProvider loggedUser={loggedUser}>
                              <Route exact path="/">
                                <HomePage
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/personal-page">
                                <PersonalPage
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/detail">
                                <ExhibitorDetail
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <SdmAlertV5
                                severity={
                                  exhibitorAlertData?.severity || 'success'
                                }
                                variant="filled"
                                icon={
                                  exhibitorAlertData?.severity === 'error' ? (
                                    <WarningAmberIcon color="error" />
                                  ) : (
                                    <CheckCircleOutlineIcon color="success" />
                                  )
                                }
                                alertData={exhibitorAlertData}
                              />
                            </ExhibitorContextProvider>
                          </Switch>
                        </Router>
                      </LoaderCountContextProvider>
                    </ThemeV5Provider>
                  </FilterContextProvider>
                </AuthContextProvider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                '/:lang/biennali',
                '/biennali',
                '/:lang/biennali2',
                '/biennali2',
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <FilterContextProvider locale={locale} isBiennali={true}>
                    <ThemeV5Provider>
                      <LoaderCountContextProvider>
                        <Router>
                          <Switch>
                            <ExhibitorContextProvider loggedUser={loggedUser}>
                              <Route exact path="/">
                                <Biennali
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <Route exact path="/detail">
                                <ExhibitorDetail
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                              <SdmAlertV5
                                severity={
                                  exhibitorAlertData?.severity || 'success'
                                }
                                variant="filled"
                                icon={
                                  exhibitorAlertData?.severity === 'error' ? (
                                    <WarningAmberIcon color="error" />
                                  ) : (
                                    <CheckCircleOutlineIcon color="success" />
                                  )
                                }
                                alertData={exhibitorAlertData}
                              />
                            </ExhibitorContextProvider>
                          </Switch>
                        </Router>
                      </LoaderCountContextProvider>
                    </ThemeV5Provider>
                  </FilterContextProvider>
                </AuthContextProvider>
              </Router>
            </Route>

            {/* <Route exact path={['/:lang/exhibitors', '/exhibitors']}>
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <FilterContextProvider locale={locale}>
                    <Router>
                      <Switch>
                        <ExhibitorContextProvider loggedUser={loggedUser}>
                          <Route exact path="/">
                            <ExhibitorsList locale={locale} />
                          </Route>
                          <Route exact path="/detail">
                            <ExhibitorPage locale={locale} />
                          </Route>
                          <Route exact path="/move-to-folder">
                            <ExhibitorMoveToFolderPage locale={locale} />
                          </Route>
                          <Route exact path="/folder-detail">
                            <ExhibitorFolderDetail locale={locale} />
                          </Route>
                        </ExhibitorContextProvider>
                      </Switch>
                    </Router>
                  </FilterContextProvider>
                </AuthContextProvider>
              </Router>
            </Route> */}
            <Route exact path={['/:lang/map', '/map']}>
              <Router>
                <Switch>
                  <Route exact path="/">
                    <ExhibitorMap locale={locale} />
                  </Route>
                </Switch>
              </Router>
            </Route>
            <Route
              exact
              path={[
                '/:lang/analytics',
                '/analytics',
                '/:lang/analytics2',
                '/analytics2',
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <ThemeV5Provider>
                    <LoaderCountContextProvider minHeight="600px">
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          <Route exact path="/">
                            <MatchMakingPage
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                      <SdmAlertV5
                        severity={matchmakingAlertData?.severity || 'warning'}
                        variant="filled"
                        showCloseIcon
                        zIndex={1400}
                        icon={
                          matchmakingAlertData?.severity === 'error' ? (
                            <WarningAmberIcon color="error" />
                          ) : (
                            <CheckCircleOutlineIcon color="success" />
                          )
                        }
                        alertData={matchmakingAlertData}
                        alertCustomStyle={{
                          alignItems: 'flex-start',
                          width: '95% !important',
                          [`@media (min-width: 768px)`]: {
                            maxWidth: '750px',
                          },
                          [`@media (min-width: 992px)`]: {
                            maxWidth: '970px',
                          },
                          [`@media (min-width: 1280px)`]: {
                            maxWidth: '1100px',
                          },
                        }}
                      />
                    </LoaderCountContextProvider>
                  </ThemeV5Provider>
                </AuthContextProvider>
              </Router>
            </Route>
            {/* <Route exact path={['/:lang/analytics', '/analytics']}>
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  {!loggedUser ? (
                    <></>
                  ) : (
                    <Switch>
                      <Route exact path="/">
                        <AnalyticsPage
                          locale={locale}
                          loggedUser={loggedUser}
                        />
                      </Route>
                    </Switch>
                  )}
                </AuthContextProvider>
              </Router>
            </Route> */}
            <Route exact path={['/:lang/booking-brand', '/booking-brand']}>
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  {!loggedUser ? (
                    <Switch>
                      <Route exact path="/">
                        <ExhibitorBooking locale={locale} user={loggedUser} />
                      </Route>
                    </Switch>
                  ) : (
                    <Switch>
                      <Route exact path="/">
                        <ExhibitorBooking locale={locale} user={loggedUser} />
                      </Route>
                    </Switch>
                  )}
                </AuthContextProvider>
              </Router>
            </Route>

            <Route
              exact
              path={[
                '/:lang/sdm-tickets/my-orders',
                'sdm-tickets/my-orders',
                '/:lang/app/sdm-tickets/my-orders',
                '/app/sdm-tickets/my-orders',
                '/:lang/sdm-tickets/my-orders2',
                '/sdm-tickets/my-orders2',
                // '/:lang/my-tickets',
                // '/my-tickets',
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <ThemeV5Provider>
                    <LoaderCountContextProvider>
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          <Route exact path="/">
                            <PersonalOrders
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                    </LoaderCountContextProvider>
                  </ThemeV5Provider>
                </AuthContextProvider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                '/:lang/sdm-tickets/my-tickets',
                'sdm-tickets/my-tickets',
                '/:lang/app/sdm-tickets/my-tickets',
                '/app/sdm-tickets/my-tickets',
                '/:lang/sdm-tickets/my-tickets2',
                '/sdm-tickets/my-tickets2',
                // '/:lang/my-tickets',
                // '/my-tickets',
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <ThemeV5Provider>
                    <LoaderCountContextProvider>
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          <Route exact path="/">
                            <PersonalTickets
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                    </LoaderCountContextProvider>
                  </ThemeV5Provider>
                </AuthContextProvider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                '/:lang/sdm-tickets/success',
                '/sdm-tickets/success',
                '/:lang/app/sdm-tickets/success',
                '/app/sdm-tickets/success',
                '/:lang/sdm-tickets/success2',
                '/sdm-tickets/success2',
                // '/:lang/success',
                // '/success',
              ]}
            >
              <Router>
                <ThemeV5Provider>
                  <LoaderCountContextProvider>
                    <AuthContextProvider
                      onLoggedUser={setUser}
                      onDetectedEmail={setDetectedEmail}
                    >
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          <Route exact path="/">
                            <SuccessPage
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                    </AuthContextProvider>
                  </LoaderCountContextProvider>
                </ThemeV5Provider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                '/:lang/sdm-tickets/pending-order',
                '/sdm-tickets/pending-order',
                '/:lang/app/sdm-tickets/pending-order',
                '/app/sdm-tickets/pending-order',
                '/:lang/sdm-tickets/pending-order2',
                '/sdm-tickets/pending-order2',
                // '/:lang/pending-order',
                // '/pending-order',
              ]}
            >
              <Router>
                <ThemeV5Provider>
                  <LoaderCountContextProvider>
                    <AuthContextProvider
                      onLoggedUser={setUser}
                      onDetectedEmail={setDetectedEmail}
                    >
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          <Route exact path="/">
                            <TicketsPendingOrderPage
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                    </AuthContextProvider>
                  </LoaderCountContextProvider>
                </ThemeV5Provider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                `/:lang${routes.agenda.salesTeam}`,
                `${routes.agenda.salesTeam}`,
                `/:lang${routes.agenda.salesTeam}2`,
                `${routes.agenda.salesTeam}2`,
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  {!loggedUser ? (
                    <></>
                  ) : (
                    <Switch>
                      <Route exact path="/">
                        <SalesTeam locale={locale} loggedUser={loggedUser} />
                      </Route>
                    </Switch>
                  )}
                </AuthContextProvider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                `/:lang${routes.agenda.booking}`,
                `${routes.agenda.booking}`,
                `/:lang${routes.agenda.booking}2`,
                `${routes.agenda.booking}2`,
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  {!loggedUser ? (
                    <></>
                  ) : (
                    <Switch>
                      <Route exact path="/">
                        <BookingPage locale={locale} loggedUser={loggedUser} />
                      </Route>
                    </Switch>
                  )}
                </AuthContextProvider>
              </Router>
            </Route>
            <Route
              exact
              path={[
                `/:lang${routes.agenda.agenda}`,
                `${routes.agenda.agenda}`,
                `/:lang${routes.agenda.agenda}2`,
                `${routes.agenda.agenda}2`,
              ]}
            >
              <Router>
                <AuthContextProvider
                  onLoggedUser={setUser}
                  onDetectedEmail={setDetectedEmail}
                >
                  <ThemeV5Provider>
                    <VisitsContextProvider>
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          {loggedUser.type === Roles.OPERATOR ? (
                            <>
                              <Route exact path="/">
                                <AgendaOperator
                                  locale={locale}
                                  loggedUser={loggedUser}
                                  detectedEmail={detectedEmail}
                                />
                              </Route>
                              <Route exact path="/detail">
                                <MyAppointmentDetail
                                  locale={locale}
                                  loggedUser={loggedUser}
                                />
                              </Route>
                            </>
                          ) : (
                            <Route exact path="/">
                              <Agenda locale={locale} loggedUser={loggedUser} />
                            </Route>
                          )}
                          <Route exact path="/create">
                            <CreateVisit
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                          <Route exact path="/request-page">
                            <RequestPage
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                    </VisitsContextProvider>
                  </ThemeV5Provider>
                </AuthContextProvider>
              </Router>
            </Route>
            <Route exact path={['/:lang/chat', '/chat']}>
              <Router>
                <SizeContextProvider>
                  <ChatSessionRouter
                    onLoggedUser={setUser}
                    onDetectedEmail={setDetectedEmail}
                    locale={locale}
                    loggedUser={loggedUser}
                  />
                </SizeContextProvider>
              </Router>
            </Route>
          </Switch>
        </AppRouter>
      </LoaderContextProvider>
    </IntlProvider>
  );
}

export default App;

/**
 * 
 *   <Route
              exact
              
              >
                <Router>
                  <AuthContextProvider
                    onLoggedUser={setUser}
                    onDetectedEmail={setDetectedEmail}
                  >
                    <CartContextProvider loggedUser={loggedUser}>
                      {!loggedUser ? (
                        <></>
                      ) : (
                        <Switch>
                          <Route exact path="/">
                            <TicketsPage
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                          <Route exact path="/editTickets">
                            <TicketsEdit
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                          <Route exact path="/merchandising">
                            <Merchandising
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                          <Route exact path="/recap">
                            <Recap locale={locale} loggedUser={loggedUser} />
                          </Route>
                          <Route exact path="/checkout">
                            <CheckoutPage
                              locale={locale}
                              loggedUser={loggedUser}
                            />
                          </Route>
                        </Switch>
                      )}
                    </CartContextProvider>
                  </AuthContextProvider>
                </Router>
              </Route>
 * 
 * 
 */
